module.exports = __webpack_public_path__ + "img/buyer-portal.5e213045.png";